import * as React from 'react'

export const CheckinChartsEmptyStateBanner: React.VFC = () => {
  return (
    <div className="absolute bg-gray-50 bottom-0 h-[72px] left-0 m-auto px-3 py-4 right-0 rounded text-center text-xs top-0 w-[234px]">
      There must be at least 1 completed Check-in to see this data
    </div>
  )
}
